<template>
  <div class="home">
    <Header></Header>
    <Banners :banner="banner"></Banners>

<!--    <div class="part1">-->
<!--      <ul>-->
<!--        <li v-for="item in part1">-->
<!--          <img :src="item.imgUrl" />-->
<!--          <p class="name">{{item.name}}</p>-->
<!--          <p class="remark">{{item.remark}}</p>-->
<!--        </li>-->
<!--      </ul>-->
<!--      <div class="clear"></div>-->
<!--    </div>-->

    <div class="part2">
      <p class="title">技术与服务精炼</p>
      <p class="text">基于数据分析的精准用户推广服务方案</p>

      <p class="content">江苏道泰信息技术有限公司拥有并基于spark大数据生态组件作为核心处理技术，对海量数据进行规整处理，刻画出用户画像体系，并不断迭代、丰富受众标签描述。在此基础上利用业务的正、负样本数据，使用TGI(TargetGroup Index)对受众行为偏好进行计算，找寻出最优质最符合条件的受众，为运营提供精准营销服务，实现千人千面的营销策略。</p>

      <ul>
        <li v-for="item in part2" :key="item.name +  item.remark">
          <img :src="item.imgUrl" />
          <p class="name">{{item.name}}</p>
          <p class="remark">{{item.remark}}</p>
        </li>
      </ul>
      <div class="clear"></div>
    </div>

    <div class="part3">
      <p class="title">公司荣誉</p>
      <img class="part3-img" :src="img1" @click="noClick"/>
      <img class="part3-img" :src="img2" @click="noClick"/>
      <img class="part3-img" :src="img3" @click="noClick"/>
      <img class="part3-img" :src="img4" @click="noClick"/>
      <img class="part3-img" :src="img5" @click="noClick"/>
      <img class="part3-img" :src="img6" @click="noClick"/>
      <div class="clear"></div>
    </div>

    <!-- <div class="part4">
      <p class="title">合作机构</p>
      <img :src="part4[0].imgUrl" alt="" style="width: 80%;display: block;margin: 0.4rem auto;">
      <div class="clear"></div>
    </div> -->

    <Footer></Footer>
  </div>
</template>

<script>
  import Header from "@/mComponents/Header"
  import Banners from "@/mComponents/Banners"
  import Footer from "@/mComponents/Footer"

  export default {
    name: 'Home',
    data() {
      return {
        banner: require("@/assets/imgs/mobile/banner-01.png"),
        img1: require("@/assets/imgs/img-honor1.png"),
        img2: require("@/assets/imgs/img-honor2.png"),
        img3: require("@/assets/imgs/img-honor3.png"),
        img4: require("@/assets/imgs/img-honor4.png"),
        img5: require("@/assets/imgs/img-honor5.png"),
        img6: require("@/assets/imgs/img-honor6.png"),
        part1: [
          {imgUrl:require("@/assets/imgs/mobile/ic-top-client.png"),name:"客户第一",remark:"深入客户、服务客户、成就客户"},
          {imgUrl:require("@/assets/imgs/mobile/ic-top-teamwork.png"),name:"团队合作",remark:"包容互助、共担共享、一起成就"},
          {imgUrl:require("@/assets/imgs/mobile/ic-top-simple.png"),name:"简化",remark:"诚实正直、直言不讳、结果导向"},
          {imgUrl:require("@/assets/imgs/mobile/ic-top-passion.png"),name:"激情",remark:"热爱工作、积极生活、挑战困难"},
          {imgUrl:require("@/assets/imgs/mobile/ic-top-study.png"),name:"教学相长",remark:"专注专业、虚心请教、主动分享"},
          {imgUrl:require("@/assets/imgs/mobile/ic-top-innovate.png"),name:"创新",remark:"善于学习、拥抱变化、创造变化"},
          ],
        part2: [
          {imgUrl:require("@/assets/imgs/mobile/ic-home-userportrait.png"),name:"用户画像",remark:"让您了解TA"},
          {imgUrl:require("@/assets/imgs/mobile/ic-home-select-crowd.png"),name:"圈定人群",remark:"让您找到TA"},
          {imgUrl:require("@/assets/imgs/mobile/ic-home-user-push.png"),name:"用户推送",remark:"让您影响TA"},
          {imgUrl:require("@/assets/imgs/mobile/ic-home-effect-optimize.png"),name:"效果优化",remark:"让您影响更多的TA"},
          ],
        part4:[
          {imgUrl:require("@/assets/imgs/mobile/img-co.png")},
        ],
      }
    },
    components: {
      Header,Banners,Footer,
    },
    created() {
      window.scrollTo(0,0);
      this.$store.commit('changeNavsM', 'mHome')
    },
    methods: {
      noClick() {
        return false;
      }
    },
    mounted() {
      $('.part1 ul li').addClass("active");
      var screenHeight =  document.documentElement.clientHeight
      setTimeout(function() {
        window.onscroll = function() {
          var bool = $(window).scrollTop()+$(window).height()==$(document).height();
          var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
          let fontSize = getComputedStyle(window.document.documentElement)['font-size'];
          if(scrollTop>30) {
            $(".icon-m-up").css("display","block")
            $(".top").addClass("active")
          } else {
            $(".icon-m-up").css("display","none")
            $(".top").removeClass("active")
          }

          if(scrollTop> (2.4* parseInt(fontSize))) {
            $('.part2 ul li:nth-child(1),.part2 ul li:nth-child(2)').addClass('active')
          }
          if(scrollTop> (4.3* parseInt(fontSize))) {
            $('.part2 ul li:nth-child(3),.part2 ul li:nth-child(4)').addClass('active')
          }

          var lis = $('.part4 ul li')
          for(var i =0;i<lis.length;i++) {
            var offsetTop = $(lis[i]).offset().top
            if(offsetTop - scrollTop - screenHeight < 0 && !bool && !$(lis[i]).hasClass('active')) {
              $(lis[i]).addClass('active')
            }
          }
        }
      },100)
    }
  }
</script>

<style  scoped lang="scss" type="text/scss">
  @import '../../assets/css/animation.css';

  .home {
    background-color: #fff;

    .clear {
      clear: both;
    }

    .part1 {
      padding-bottom: 0.7rem;
      ul {
        margin: 0 0.45rem;
        min-height: 8rem;
        li {
          width: 3rem;
          height: 2.4rem;
          background:rgba(238,238,238,1);
          border-radius:8px;
          float: left;
          margin: 0.3rem 0.15rem 0;
          &.active img{
             -moz-animation: RotateY 0.5s linear forwards;
             -ms-animation: RotateY 0.5s linear forwards;
             -webkit-animation: RotateY 0.5s linear forwards;
             -o-animation: RotateY 0.5s linear forwards;
             animation: RotateY 0.5s linear forwards;
           }
          img {
            display: block;
            width: 2.8rem;
            margin: 0.1rem auto 0;
            min-height: 1rem;
            transform:RotateY(90deg);
            -ms-transform:RotateY(90deg); 	/* IE 9 */
            -moz-transform:RotateY(90deg); 	/* Firefox */
            -webkit-transform:RotateY(90deg); /* Safari 和 Chrome */
            -o-transform:RotateY(90deg); 	/* Opera */
          }
          p {
            text-align: center;
          }
          .name {
            font-size:0.24rem;
            font-family:PingFangSC-Medium;
            font-weight:500;
            color:rgba(0,0,0,1);
            margin: 0.03rem 0;
          }
          .remark {
            font-size:0.18rem;
            font-family:PingFangSC-Medium;
            font-weight:500;
            color:rgba(0,0,0,1);
            opacity:0.6;
          }
        }
      }
    }

    .part2 {
      padding-bottom: 0.5rem;
      padding-top: 0.45rem;
      /*background:rgba(237,237,237,1);*/
      background: #fff;
      p {
        text-align: center;
      }
      .title {
        font-size:0.4rem;
        line-height: 0.5rem;
        font-family:PingFangSC-Medium;
        font-weight:500;
        color:rgba(0,0,0,1);
      }
      .text {
        font-size:0.3rem;
        line-height: 0.5rem;
        font-family:PingFangSC-Regular;
        font-weight:400;
        color:rgba(0,0,0,1);
        opacity:0.6;
      }
      .content {
        font-size:0.24rem;
        font-family:PingFangSC-Medium;
        font-weight:500;
        color:rgba(0,0,0,1);
        line-height:0.4rem;
        margin: 0.3rem 0.4rem 0;
        text-align: left;
        span {
          display: inline-block;
          font-size: 0.6rem;
          line-height: 0.8rem;
          font-weight: 500;
          font-weight: 500;
          margin: 0 0.1rem;
        }
        span:nth-child(1) {
          color: #4196ff;
        }
        span:nth-child(2) {
          color: #FB6604;
        }
        span:nth-child(3) {
          color: #00d929;
        }
      }
      ul {
        margin: 0.2rem 0.45rem 0;
        display: inline-block;
        li {
          width: 3rem;
          float: left;
          margin: 0.3rem 0.15rem 0;
          &.active img {
             -moz-animation: RotateY 0.5s linear forwards;
             -ms-animation: RotateY 0.5s linear forwards;
             -webkit-animation: RotateY 0.5s linear forwards;
             -o-animation: RotateY 0.5s linear forwards;
             animation: RotateY 0.5s linear forwards;
           }
          img {
            /*opacity: 0;*/
            display: block;
            width: 1.92rem;
            margin: 0.1rem auto 0;
            /*transform:RotateY(90deg);*/
            /*-ms-transform:RotateY(90deg); 	!* IE 9 *!*/
            /*-moz-transform:RotateY(90deg); 	!* Firefox *!*/
            /*-webkit-transform:RotateY(90deg); !* Safari 和 Chrome *!*/
            /*-o-transform:RotateY(90deg); 	!* Opera *!*/
          }
          .name {
            font-size:0.24rem;
            line-height: 0.55rem;
            font-family:PingFangSC-Medium;
            font-weight:500;
            color:rgba(0,0,0,1);
            margin: 0.03rem 0;
          }
          .remark {
            font-size:0.18rem;
            line-height: 0.3rem;
            font-family:PingFangSC-Medium;
            font-weight:500;
            color:rgba(136,136,136,1);
          }
        }
      }
    }

    .part3 {
      background:rgba(237,237,237,1);
      padding: 0.45rem 0;
      .title {
        font-size:0.4rem;
        line-height: 0.6rem;
        font-family:PingFangSC-Medium;
        font-weight:500;
        color:rgba(0,0,0,1);
        text-align: center;
      }
      .part3-img{
        width: 6rem;
        display: block;
        margin: 0.4rem auto 0.5rem;
      }
      table {
        margin: 0 0.3rem;
        border-top:0.01rem solid rgba(204,204,204,1);
        border-left:0.01rem solid rgba(204,204,204,1);
        tr {
          td {
            width: 3.45rem;
            height: 0.7rem;
            line-height: 0.7rem;
            font-size: 0.2rem;
            font-family:PingFangSC-Medium;
            font-weight:500;
            color:rgba(40,40,40,1);
            padding-left: 0.2rem;
            box-sizing: border-box;
            border-bottom:0.01rem solid rgba(204,204,204,1);
            border-right:0.01rem solid rgba(204,204,204,1);
          }
        }
      }
    }

    .part4 {
      padding: 0.5rem 0 0.8rem;
      background-color: #fff;
      p {
        text-align: center;
      }
      .title {
        font-size:0.4rem;
        line-height: 0.6rem;
        font-family:PingFangSC-Medium;
        font-weight:500;
        color:rgba(0,0,0,1);
      }
      ul {
        margin: 0 0.65rem;
        li {
          float: left;
          width: 2.8rem;
          height: 0.8rem;
          margin: 0.3rem 0.15rem 0;
          &.active img{
             -moz-animation: RotateY 0.5s linear forwards;
             -ms-animation: RotateY 0.5s linear forwards;
             -webkit-animation: RotateY 0.5s linear forwards;
             -o-animation: RotateY 0.5s linear forwards;
             animation: RotateY 0.5s linear forwards;
          }
          img {
            opacity: 0;
            width: 2.8rem;
            display: inline-block;
            transform:RotateY(90deg);
            -ms-transform:RotateY(90deg); 	/* IE 9 */
            -moz-transform:RotateY(90deg); 	/* Firefox */
            -webkit-transform:RotateY(90deg); /* Safari 和 Chrome */
            -o-transform:RotateY(90deg); 	/* Opera */
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Mobile/Home.vue